import {
  BookmarksOutlined,
  GroupWorkOutlined,
  PlayArrow,
  ExpandMore,
  RadioButtonUnchecked,
  RadioButtonCheckedSharp,
  FiberManualRecord,
  ChevronRight
} from '@material-ui/icons'
import { spacing } from '../theme'
import { Avatar } from '@material-ui/core'

export const IconMap = new Map([
  [
    'BookmarksOutlined',
    <BookmarksOutlined
      style={{ fontSize: spacing * 5 }}
      key="BookmarksOutlined"
    />
  ],
  [
    'GroupWorkOutlined',
    <GroupWorkOutlined key="GroupWorkOutlined" fontSize="large" />
  ],
  [
    'DetailsOutlined',
    <PlayArrow
      style={{
        transform: 'rotate(90deg)',
        color: 'white',
        fontSize: spacing * 4
      }}
      key="DetailsOutlined"
    />
  ],
  [
    'DetailsOutlinedRotate',
    <PlayArrow
      style={{
        transform: 'rotate(148deg)',
        color: 'white',
        fontSize: spacing * 4
      }}
      key="DetailsOutlined"
    />
  ],
  [
    'ExpandMore',
    <ExpandMore key="ExpandMore" fontSize="large" style={{ color: 'white' }} />
  ],
  [
    'ChevronRight',
    <ChevronRight
      key="ChevronRight"
      fontSize="large"
      style={{ color: 'white' }}
    />
  ],
  [
    'FiberManualRecord',
    <FiberManualRecord key="FiberManualRecord" fontSize="large" />
  ],
  [
    'RadioButtonUnchecked',
    <RadioButtonUnchecked key="RadioButtonUnchecked" fontSize="large" />
  ],
  [
    'RadioButtonCheckedSharp',
    <RadioButtonCheckedSharp key="RadioButtonCheckedSharp" fontSize="large" />
  ],
  ['México', <Avatar src="./images/mex.png" alt="logo" key="México" />],
  ['Guatemala', <Avatar src="./images/gtm.png" alt="logo2" key="Guatemala" />],
  ['Honduras', <Avatar src="./images/hnd.png" alt="logo3" key="Honduras" />],
  [
    'El Salvador',
    <Avatar src="./images/slv.png" alt="logo4" key="El Salvador" />
  ]
])
